import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../styles/Login.css'; // Import du CSS externe

const LoginForm = () => {
  const [showError, setShowError] = useState(false);
  const { login, error } = useAuth();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    username: Yup.string().required("Nom d'utilisateur requis"),
    password: Yup.string().required('Mot de passe requis'),
  });

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      const success = await login(values);
      if (success) {
        navigate('/');
      } else {
        setShowError(true);
      }
    },
  });

  return (
    <div className="login-page-bg">
      <div className="login-center-box">
        <h2 className="login-title">Connexion à votre compte</h2>
        <p className="login-desc">
          Veuillez entrer vos identifiants pour accéder à votre compte
        </p>
        {showError && error && (
          <Alert variant="danger" className="login-alert">
            {typeof error === 'object'
              ? Object.entries(error).map(([key, value]) => (
                  <div key={key}>
                    <strong>{key}:</strong> {value}
                  </div>
                ))
              : error}
          </Alert>
        )}
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              name="username"
              placeholder="Entrez votre nom d'utilisateur"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.username && formik.errors.username}
              className="login-input"
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.username}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Control
              type="password"
              name="password"
              placeholder="Entrez votre mot de passe"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.password && formik.errors.password}
              className="login-input"
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.password}
            </Form.Control.Feedback>
          </Form.Group>
          <div className="login-forgot">
            <a href="/forgot-password">Mot De Passe Oublié ?</a>
          </div>
          <Button
            variant="primary"
            type="submit"
            className="login-btn"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? 'Connexion...' : 'CONNEXION'}
          </Button>
        </Form>
        <div className="login-bottom">Pas encore de compte ?</div>
        <Button
          variant="secondary"
          className="login-btn"
          onClick={() => navigate('/register')}
        >
          INSCRIPTION
        </Button>
      </div>
    </div>
  );
};

export default LoginForm;
